import ApiClient from "@/api/ApiClient";

export const TAXI_ADMIN_DATA_OUTPUT = "opTaxiAdminData";
export const TAXI_FLEET_VIEW_MODE = "fleet";

export interface TaxiFleetItem {
  id: number;
  license: string;
  location: {
    lat: number;
    lng: number;
  };
  taxiState: number;
  stopId?: number;
  stopTs?: string;
  zoneId?: number;
  zoneTs?: string;
  targetNFinish?: number;
  zoneNFinish?: number;
  ooc: boolean;
  reqsTD: number[];
}
type TaxiFleetResponse = TaxiFleetItem[];

export async function getTaxisByWorkgroup(wgId: number) {
  return (
    await ApiClient().get("taxis", {
      params: {
        wgId,
      },
    })
  ).data;
}

export async function getFleet(wgId: number, centralId: number) {
  return (
    await ApiClient().get<TaxiFleetResponse>("taxis2", {
      params: {
        wgId,
        centralId,
        viewMode: TAXI_FLEET_VIEW_MODE,
      },
    })
  ).data;
}

export async function getTaxisByWorkgroupAndOutput(wgId: number, output: string) {
  return (
    await ApiClient().get("taxis2", {
      params: {
        wgId,
        output,
      },
    })
  ).data;
}

export async function getTaxiById(wgId: number, centralId: number, taxiId: number) {
  const params = {
    output: TAXI_ADMIN_DATA_OUTPUT,
    wgId,
    centralId,
    taxiId,
  };
  return (
    await ApiClient().get("taxis2", {
      params,
    })
  ).data;
}

export async function getAgenda(wgId: number) {
  return (
    await ApiClient().get("taxis/agenda", {
      params: {
        wgId,
      },
    })
  ).data;
}

export async function ejectTaxi(wgId: number, centralId: number, taxiId: number) {
  const params = {
    wgId,
    centralId,
    taxiId,
  };
  await ApiClient().put("taxis/eject", null, {
    params,
  });
}
